import {useEffect, useState} from 'react';
import {clearFetchCache, getCachedOrFetch} from '../../utils/fetchCache';
import {buildFieldPreviewModel} from '../../utils/fieldPreview/buildFieldPreviewModel';

const getCacheKey = (path) => `field-preview:${path}`;

// Файл поля неизменен до следующего выпуска, а его собирает и страница выбора,
// и возврат на нее: схему считаем один раз за сессию
const loadFieldPreviewModel = (path) => getCachedOrFetch(getCacheKey(path), () => (
  fetch(path).then((response) => {
    if (!response.ok) {
      throw new Error(`Field file is not available: ${path}`);
    }
    return response.json();
  }).then(buildFieldPreviewModel)
), Infinity).catch((error) => {
  // Неудачу не запоминаем: следующий показ страницы попробует снова
  clearFetchCache(getCacheKey(path));
  throw error;
});

/**
 * Модель схемы поля для плитки выбора карты.
 *
 * @param {string} [path] — путь к файлу поля; у пустого поля файла нет
 * @returns {Object|null} модель; null — пока не загружена или показывать нечего
 */
export const useFieldPreviewModel = (path) => {
  const [model, setModel] = useState(null);

  useEffect(() => {
    if (!path) {
      setModel(null);
      return undefined;
    }

    let isActual = true;
    loadFieldPreviewModel(path)
      .then((nextModel) => {
        if (isActual) {
          setModel(nextModel);
        }
      })
      .catch((error) => {
        console.warn('[FieldPreview] Схема поля недоступна', path, error);
        if (isActual) {
          setModel(null);
        }
      });

    return () => {
      isActual = false;
    };
  }, [path]);

  return model;
};
